var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChildIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 6,
    height: 16,
    viewBox: "0 0 6 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4588_30349)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.10634 3.68228C4.96727 3.0341 5.17012 1.76789 4.55942 0.854125C3.94872 -0.0596419 2.75572 -0.274942 1.89479 0.373239C1.03386 1.02142 0.831009 2.28763 1.44171 3.2014C2.05241 4.11516 3.24541 4.33046 4.10634 3.68228Z",
    fill: "#000A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.06352 4.64062H4.93556C5.52242 4.64062 5.99908 5.14653 5.99908 5.76942V10.4289C5.99908 10.7496 5.75386 11.0088 5.45263 11.0088H0.546456C0.244298 11.0088 0 10.7486 0 10.4289V5.76942C0 5.14653 0.476657 4.64062 1.06352 4.64062Z",
    fill: "#000A0A"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.925781 5.75V15.1352C0.925781 15.6128 1.29131 16.0008 1.74133 16.0008H2.33922C2.5927 16.0008 2.79751 15.7824 2.79751 15.5143V11.9457C2.79751 11.8063 2.93894 11.7566 2.99956 11.7566C3.06018 11.7566 3.20161 11.8063 3.20161 11.9457V15.5143C3.20161 15.7834 3.40734 16.0008 3.6599 16.0008H4.25779C4.70781 16.0008 5.07334 15.6128 5.07334 15.1352V5.75H0.925781Z",
    fill: "#000A0A"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4588_30349"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChildIcon);
export default __webpack_public_path__ + "static/media/child-icon.ff94ea445d9a25249cb2264f1d7e8c9d.svg";
export { ForwardRef as ReactComponent };